<template>
  <div>
    <h2 class="section-title">Benefícios que aparecem no dia seguinte</h2>
    <p class="section-subtitle">
      Não é só “fazer mais telas”. É reduzir as pequenas falhas que custam tempo, energia e confiança.
    </p>

    <div class="benefits">
      <div class="benefit card">
        <div class="b-icon" aria-hidden="true">🚀</div>
        <h3 class="b-title">Mais produtividade</h3>
        <p class="b-text">Menos busca manual e mais decisões com informações já prontas para o time.</p>
      </div>
      <div class="benefit card">
        <div class="b-icon" aria-hidden="true">✅</div>
        <h3 class="b-title">Redução de erros</h3>
        <p class="b-text">Fluxos consistentes diminuem retrabalho e evitam inconsistências entre agenda e financeiro.</p>
      </div>
      <div class="benefit card">
        <div class="b-icon" aria-hidden="true">🤝</div>
        <h3 class="b-title">Melhor atendimento ao paciente</h3>
        <p class="b-text">Mais previsibilidade para o responsável e rotina mais estável para o cuidado.</p>
      </div>
      <div class="benefit card">
        <div class="b-icon" aria-hidden="true">📍</div>
        <h3 class="b-title">Mais organização</h3>
        <p class="b-text">Visão operacional da clínica para você manter tudo no lugar, inclusive em dias cheios.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'BenefitsSection' }
</script>

<style scoped>
.benefits {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 22px;
}

.b-icon {
  width: 44px;
  height: 44px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(77, 186, 135, 0.12);
  font-size: 18px;
}

.b-title {
  margin: 14px 0 6px;
  font-size: 16px;
}

.b-text {
  margin: 0;
  color: var(--easy-muted);
  line-height: 1.55;
  font-size: 14px;
}

@media (max-width: 980px) {
  .benefits {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .benefits {
    grid-template-columns: 1fr;
  }
}
</style>
